const STORAGE_KEY = 'zg-radio-presence-id';
/** Keep under free KV write budget (~1k/day): ~720 writes/day per always-on tab. */
export const RADIO_PRESENCE_INTERVAL_MS = 120_000;

function presenceBase(): string {
  const fromEnv = import.meta.env.VITE_PRESENCE_BASE;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).replace(/\/$/, '');
  }
  return 'https://presence.thisiszacharygray.com';
}

function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID().replace(/-/g, '').slice(0, 32);
  }
  return `r${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
}

export function getRadioPresenceSessionId(): string {
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing && /^[A-Za-z0-9_-]{8,64}$/.test(existing)) return existing;
    const id = randomId();
    sessionStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return randomId();
  }
}

export async function touchRadioPresence(trackId?: string): Promise<void> {
  const sessionId = getRadioPresenceSessionId();
  try {
    await fetch(`${presenceBase()}/presence`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId,
        ...(trackId ? { trackId } : {}),
      }),
      keepalive: true,
      cache: 'no-store',
    });
  } catch {
    /* soft — presence must never break playback */
  }
}

export function leaveRadioPresence(): void {
  const sessionId = getRadioPresenceSessionId();
  const url = `${presenceBase()}/presence?sessionId=${encodeURIComponent(sessionId)}`;
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      // sendBeacon is POST-only; worker accepts POST leave via body? Use DELETE fetch.
      // Prefer fetch keepalive for DELETE.
    }
  } catch {
    /* fall through */
  }
  void fetch(url, { method: 'DELETE', keepalive: true, cache: 'no-store' }).catch(
    () => {},
  );
}
